import { AddSubUserFormSchema } from '../../../components/pages/connected/Profile/ProfileSubUsersENT/AddSubUserENTModal/AddSubUserENTForm/AddSubUserENTForm.types';
import { UpdateSubUserFormSchema } from '../../../components/pages/connected/Profile/ProfileSubUsersENT/UpdateSubUserModal/UpdateSubUserForm/UpdateSubUserForm.types';
import { StaticGetEndpoints } from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const USERS_ENDPOINTS = Object.freeze({
  infos: () => api.get(StaticGetEndpoints.CurrentUserInfos),
  logo: () => api.get(StaticGetEndpoints.CurrentUserLogo, {}, {
    responseType: 'blob'
  }),

  subUsersENT: () => api.get(StaticGetEndpoints.SubUsersENT),
  updateSubUsersENT: (subUserId: number, data: UpdateSubUserFormSchema) => 
    api.put(`users/sub/ENT/update/${subUserId}`, data),
  addSubUsersENT: (data: AddSubUserFormSchema) => 
    api.post(`users/sub/ENT/create`, data),
});
